export default __webpack_public_path__ + "static/media/ogunrionola.6f522c58.png";